import { ComponentFactoryResolver, Directive, Input, OnInit, ViewContainerRef } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { CheckboxComponent } from '../../components/checkbox/checkbox.component';
import { InputComponent } from '../../components/input/input.component';
import { NumberComponent } from '../../components/number/number.component';
import { PhoneComponent } from '../../components/phone/phone.component';
import { RadiobuttonComponent } from '../../components/radiobutton/radiobutton.component';
import { SelectComponent } from '../../components/select/select.component';
import { TextareaComponent } from '../../components/textarea/textarea.component';

const componentMapper = {
    phone: PhoneComponent,
    phonenumber: PhoneComponent,
    text: InputComponent,
    email: InputComponent,
    select: SelectComponent,
    radio: RadiobuttonComponent,
    booleancheckbox: CheckboxComponent,
    checkbox: CheckboxComponent,
    textarea: TextareaComponent,
    number: NumberComponent
};

@Directive({
    selector: '[daDynamicField]',
    standalone: false
})
export class DynamicFieldDirective implements OnInit {
    public componentRef: any;

    @Input() reactiveFormData: UntypedFormGroup;
    @Input() control: any;
    @Input() formId: string;

    constructor(private _resolver: ComponentFactoryResolver, private _container: ViewContainerRef) {}

    ngOnInit() {
        if (componentMapper[this.control.fieldType.toLowerCase()]) {
            const _fieldType = this.control.fieldType.toLowerCase();
            const _fieldName = this.control.name.toLowerCase();
            let factory = null;
            if ((_fieldType === 'text' || _fieldType === 'phonenumber') && _fieldName === 'phone') {
                factory = this._resolver.resolveComponentFactory(componentMapper['phone']);
            } else {
                factory = this._resolver.resolveComponentFactory(componentMapper[_fieldType]);
            }
            this.componentRef = this._container.createComponent(factory);
            this.componentRef.instance.formId = this.formId;
            this.componentRef.instance.field = this.control;
            this.componentRef.instance.group = this.reactiveFormData;
        } else {
            throw new Error('No field component for ' + this.control.fieldType.toLowerCase());
        }
    }
}
